<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const breadcrumbs = computed(() => {
  const raw = route.meta?.breadcrumb || []
  const result = []
  for (let i = 0; i < raw.length; i++) {
    result.push(raw[i]);
  }
  if(route.meta.title) {
    result.push({title:route.meta.title});
  }
  return result
})
</script>

<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item" v-for="item in breadcrumbs">
        <template v-if="item.name">
          <router-link :to="{ name: item.name}">
            {{ item.title }}
          </router-link>
        </template>
        <template v-else>
          {{ item.title }}
        </template>
      </li>
    </ol>
  </nav>

</template>

<style scoped lang="scss">

</style>